<template>
  <div id="botpress-webchat"></div>
</template>

<script>
export default {
  data() {
    return {
      municipio: null,
    };
  },

  async mounted() {
    // 1️⃣ Pega município
    await this.buscarMunicipio();

    // 2️⃣ Carrega o script principal do Botpress Webchat (obrigatório)
    await this.carregarScript("https://cdn.botpress.cloud/webchat/v3.5/inject.js");

    // 3️⃣ Carrega o script de DEPLOY (contém ícone, cores, título etc)
    await this.carregarScript("https://files.bpcontent.cloud/2025/07/24/18/20250724185805-5QD7JGXY.js");

    console.log("🔹 Botpress carregado…");

    // 4️⃣ Inicializa SEM configuration para usar o Deploy Settings
    window.botpress.init({
      botId: "0f7f4160-efbc-44cc-87db-1a11ee43254d",
      clientId: "adfd8c8f-393a-4029-8f54-f3f1802fb098"
    });

    window.botpress.on("webchat:ready", () => {
      console.log("Webchat aberto!", this.municipio);

      const customEvent = {
        type: "customEvent",
        channel: "web",
        payload: { text: "municipio_inicial" },
        extraProps: {
          municipio: this.municipio,
          cod_user: this.$store.state.user.id,
          nome_user: this.$store.state.user.name,
          email_user: this.$store.state.user.email,
          unidade_id: this.$store.state.user.tecnico.unidade_id,
          unidade_nome: this.$store.state.user.tecnico.unidade.nome,
        },
      };

      window.botpress.sendEvent(customEvent);
    });
  },

  methods: {
    carregarScript(src) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          return resolve();
        }
        const s = document.createElement("script");
        s.src = src;
        s.defer = true;
        s.onload = resolve;
        s.onerror = reject;
        document.body.appendChild(s);
      });
    },

    async buscarMunicipio() {
      this.municipio = this.$store.state.municipio;
      if (!this.municipio) {
        const params = new URLSearchParams(window.location.search);
        this.municipio = params.get("municipio") || "não identificado";
      }
      console.log("🏙️ Município:", this.municipio);
    },
  },
};
</script>
